export const ProgramArray = [
    {
        id: 58,
        target: 'full',
        routine: [
            42, 0, 18, 0, 30, 0, 24, 0, 16, 0, 39, 0, 40, 0, 43, 0, 45, 0, 13,
        ],
    },
    {
        id: 60,
        target: 'full',
        routine: [
            43, 0, 44, 0, 18, 0, 51, 0, 37, 0, 13, 0, 40, 0, 42, 0, 32, 0, 45,
        ],
    },
    {
        id: 62,
        target: 'full',
        routine: [43, 0, 20, 0, 33, 0, 15, 0, 12, 0, 6, 0, 46, 0, 25, 0, 45, 0, 35],
    },
    {
        id: 64,
        target: 'full',
        routine: [
            47, 0, 28, 0, 16, 0, 45, 0, 17, 0, 35, 0, 29, 0, 43, 0, 13, 0, 51,
        ],
    },
    {
        id: 66,
        target: 'full',
        routine: [
            40, 0, 30, 0, 37, 0, 43, 0, 45, 0, 38, 0, 31, 0, 16, 0, 27, 0, 32,
        ],
    },
    {
        id: 67,
        target: 'full',
        routine: [
            16, 0, 26, 0, 17, 0, 45, 0, 35, 0, 15, 0, 27, 0, 19, 0, 47, 0, 33,
        ],
    },
    {
        id: 70,
        target: 'full',
        routine: [
            44, 0, 17, 0, 46, 0, 36, 0, 12, 0, 42, 0, 35, 0, 40, 0, 33, 0, 15,
        ],
    },
    {
        id: 72,
        target: 'full',
        routine: [
            12, 0, 42, 0, 45, 0, 13, 0, 16, 0, 34, 0, 30, 0, 39, 0, 27, 0, 40,
        ],
    },
    {
        id: 74,
        target: 'full',
        routine: [
            32, 0, 20, 0, 12, 0, 33, 0, 18, 0, 37, 0, 25, 0, 16, 0, 23, 0, 44,
        ],
    },
    {
        id: 76,
        target: 'full',
        routine: [
            27, 0, 46, 0, 49, 0, 16, 0, 12, 0, 28, 0, 11, 0, 43, 0, 33, 0, 47,
        ],
    },
    {
        id: 78,
        target: 'full',
        routine: [
            12, 0, 29, 0, 11, 0, 33, 0, 50, 0, 48, 0, 46, 0, 38, 0, 36, 0, 27,
        ],
    },
    {
        id: 80,
        target: 'full',
        routine: [
            26, 0, 31, 0, 12, 0, 32, 0, 30, 0, 19, 0, 47, 0, 46, 0, 27, 0, 48,
        ],
    },
    {
        id: 82,
        target: 'full',
        routine: [
            46, 0, 44, 0, 51, 0, 23, 0, 43, 0, 32, 0, 45, 0, 42, 0, 30, 0, 49,
        ],
    },
    {
        id: 84,
        target: 'full',
        routine: [
            34, 0, 42, 0, 46, 0, 27, 0, 22, 0, 49, 0, 39, 0, 12, 0, 11, 0, 33,
        ],
    },
    {
        id: 86,
        target: 'full',
        routine: [
            33, 0, 12, 0, 50, 0, 40, 0, 30, 0, 20, 0, 23, 0, 16, 0, 27, 0, 36,
        ],
    },
    {
        id: 88,
        target: 'full',
        routine: [
            30, 0, 25, 0, 31, 0, 27, 0, 21, 0, 22, 0, 45, 0, 28, 0, 37, 0, 40,
        ],
    },
    {
        id: 90,
        target: 'full',
        routine: [
            29, 0, 11, 0, 16, 0, 34, 0, 51, 0, 38, 0, 35, 0, 30, 0, 40, 0, 22,
        ],
    },
    {
        id: 92,
        target: 'full',
        routine: [
            27, 0, 26, 0, 30, 0, 11, 0, 16, 0, 21, 0, 40, 0, 19, 0, 46, 0, 47,
        ],
    },
    {
        id: 94,
        target: 'full',
        routine: [
            47, 0, 44, 0, 30, 0, 40, 0, 48, 0, 24, 0, 42, 0, 46, 0, 31, 0, 27,
        ],
    },
    {
        id: 96,
        target: 'full',
        routine: [
            45, 0, 16, 0, 21, 0, 27, 0, 46, 0, 42, 0, 13, 0, 12, 0, 40, 0, 37,
        ],
    },
    {
        id: 98,
        target: 'full',
        routine: [
            46, 0, 39, 0, 23, 0, 40, 0, 34, 0, 18, 0, 51, 0, 20, 0, 49, 0, 43,
        ],
    },
    {
        id: 100,
        target: 'full',
        routine: [
            25, 0, 23, 0, 43, 0, 21, 0, 45, 0, 28, 0, 50, 0, 51, 0, 27, 0, 48,
        ],
    },
    {
        id: 102,
        target: 'full',
        routine: [
            16, 0, 29, 0, 46, 0, 31, 0, 12, 0, 50, 0, 33, 0, 38, 0, 40, 0, 20,
        ],
    },
    {
        id: 104,
        target: 'full',
        routine: [
            36, 0, 26, 0, 51, 0, 27, 0, 15, 0, 49, 0, 19, 0, 30, 0, 17, 0, 40,
        ],
    },
    {
        id: 106,
        target: 'full',
        routine: [
            51, 0, 43, 0, 34, 0, 33, 0, 12, 0, 44, 0, 15, 0, 46, 0, 27, 0, 49,
        ],
    },
    {
        id: 108,
        target: 'upper',
        routine: [
            37, 0, 44, 0, 32, 0, 43, 0, 18, 0, 49, 0, 39, 0, 51, 0, 15, 0, 21,
        ],
    },
    {
        id: 110,
        target: 'upper',
        routine: [
            37, 0, 32, 0, 43, 0, 18, 0, 20, 0, 47, 0, 50, 0, 13, 0, 51, 0, 39,
        ],
    },
    {
        id: 112,
        target: 'upper',
        routine: [
            35, 0, 26, 0, 47, 0, 16, 0, 17, 0, 37, 0, 42, 0, 45, 0, 48, 0, 34,
        ],
    },
    {
        id: 114,
        target: 'upper',
        routine: [
            35, 0, 47, 0, 16, 0, 17, 0, 28, 0, 24, 0, 49, 0, 15, 0, 45, 0, 25,
        ],
    },
    {
        id: 116,
        target: 'upper',
        routine: [
            50, 0, 29, 0, 36, 0, 12, 0, 31, 0, 35, 0, 19, 0, 33, 0, 22, 0, 34,
        ],
    },
    {
        id: 118,
        target: 'upper',
        routine: [
            50, 0, 36, 0, 12, 0, 31, 0, 38, 0, 34, 0, 21, 0, 48, 0, 33, 0, 29,
        ],
    },
    {
        id: 120,
        target: 'upper',
        routine: [
            21, 0, 25, 0, 49, 0, 46, 0, 23, 0, 34, 0, 38, 0, 27, 0, 11, 0, 36,
        ],
    },
    {
        id: 122,
        target: 'upper',
        routine: [
            21, 0, 49, 0, 46, 0, 11, 0, 19, 0, 47, 0, 34, 0, 22, 0, 27, 0, 26,
        ],
    },
    {
        id: 124,
        target: 'upper',
        routine: [
            34, 0, 39, 0, 24, 0, 30, 0, 13, 0, 50, 0, 28, 0, 40, 0, 48, 0, 32,
        ],
    },
    {
        id: 126,
        target: 'upper',
        routine: [
            34, 0, 24, 0, 30, 0, 23, 0, 42, 0, 37, 0, 32, 0, 48, 0, 40, 0, 44,
        ],
    },
    {
        id: 128,
        target: 'lower',
        routine: [
            26, 0, 43, 0, 37, 0, 22, 0, 39, 0, 51, 0, 29, 0, 34, 0, 23, 0, 28,
        ],
    },
    {
        id: 130,
        target: 'lower',
        routine: [
            14.1, 0, 14.2, 0, 43, 0, 22, 0, 24, 0, 25, 0, 28, 0, 11, 0, 51, 0, 47,
        ],
    },
    {
        id: 132,
        target: 'lower',
        routine: [
            29, 0, 16, 0, 35, 0, 18, 0, 25, 0, 45, 0, 20, 0, 47, 0, 13, 0, 44,
        ],
    },
    {
        id: 134,
        target: 'lower',
        routine: [
            20, 0, 44, 0, 16, 0, 48, 0, 36, 0, 42, 0, 39, 0, 31, 0, 45, 0, 34,
        ],
    },
    {
        id: 136,
        target: 'lower',
        routine: [
            25, 0, 12, 0, 50, 0, 17, 0, 44, 0, 33, 0, 28, 0, 36, 0, 15, 0, 20,
        ],
    },
    {
        id: 138,
        target: 'lower',
        routine: [
            26, 0, 28, 0, 12, 0, 15, 0, 47, 0, 14.1, 0, 14.2, 0, 17, 0, 33, 0, 50,
        ],
    },
    {
        id: 140,
        target: 'lower',
        routine: [
            39, 0, 46, 0, 21, 0, 31, 0, 26, 0, 27, 0, 38, 0, 32, 0, 48, 0, 19,
        ],
    },
    {
        id: 142,
        target: 'lower',
        routine: [
            25, 0, 19, 0, 46, 0, 13, 0, 32, 0, 44, 0, 42, 0, 18, 0, 27, 0, 47,
        ],
    },
    {
        id: 144,
        target: 'lower',
        routine: [
            19, 0, 18, 0, 34, 0, 11, 0, 25, 0, 40, 0, 39, 0, 49, 0, 22, 0, 26,
        ],
    },
    {
        id: 146,
        target: 'lower',
        routine: [
            39, 0, 20, 0, 30, 0, 23, 0, 34, 0, 26, 0, 28, 0, 17, 0, 40, 0, 49,
        ],
    },
    {
        id: 148,
        target: 'core',
        routine: [
            41.1, 0, 41.2, 0, 47, 0, 43, 0, 44, 0, 11, 0, 22, 0, 42, 0, 16, 0, 18,
        ],
    },
    {
        id: 150,
        target: 'core',
        routine: [
            18, 0, 15, 0, 50, 0, 16, 0, 26, 0, 48, 0, 31, 0, 19, 0, 12, 0, 17,
        ],
    },
    {
        id: 152,
        target: 'core',
        routine: [
            11, 0, 22, 0, 35, 0, 12, 0, 29, 0, 41.1, 0, 41.2, 0, 38, 0, 46, 0, 31,
        ],
    },
    {
        id: 154,
        target: 'core',
        routine: [
            13, 0, 48, 0, 21, 0, 46, 0, 25, 0, 18, 0, 23, 0, 28, 0, 30, 0, 11,
        ],
    },
    {
        id: 156,
        target: 'full',
        routine: [
            41.1, 0, 41.2, 0, 36, 0, 30, 0, 39, 0, 23, 0, 17, 0, 20, 0, 51, 0, 22,
        ],
    },
];
